module.exports = __webpack_public_path__ + "static/media/notify-off.a355d632.svg";